import { computeForMonth } from "@vulpari/core";
import { useMemo } from "react";

import { useStore } from "../store.js";
import { Canvas } from "./Canvas.js";
import { BulkPanel } from "./BulkPanel.js";
import { ConfirmDialog } from "./ConfirmDialog.js";
import { EmptyState } from "./EmptyState.js";
import { FlowInspector } from "./FlowInspector.js";
import { Inspector } from "./Inspector.js";
import { Notice } from "./Notice.js";
import { Runway } from "./Runway.js";
import { SafeToSpend } from "./SafeToSpend.js";
import { Timeline } from "./Timeline.js";
import { Toolbar } from "./Toolbar.js";

export function Workspace() {
  const nodes = useStore((state) => state.nodes);
  const flows = useStore((state) => state.flows);
  const context = useStore((state) => state.context);
  const view = useStore((state) => state.view);
  const startMonth = useStore((state) => {
    const ledger = state.ledgers.find((entry) => entry.id === state.currentLedgerId);
    return ledger?.startMonth ?? state.context.month;
  });

  // The shared engine runs right here in the browser. Balances are carried
  // forward from the ledger's start month to the viewed month, so a card draws
  // down and cash accumulates as you step through the months.
  const { openingNodes, result } = useMemo(
    () =>
      computeForMonth({
        nodes,
        flows,
        startMonth,
        month: context.month,
        primaryCurrency: context.primaryCurrency,
        rates: context.rates,
      }),
    [nodes, flows, startMonth, context.month, context.primaryCurrency, context.rates],
  );

  return (
    <div className="flex h-full flex-col">
      <Toolbar />
      <div className="relative flex-1 overflow-hidden">
        {view === "runway" ? (
          <Runway />
        ) : view === "timeline" ? (
          <Timeline />
        ) : (
          <>
            <Canvas nodes={openingNodes} balances={result.balances} moves={result.moves} />
            {nodes.length === 0 ? <EmptyState /> : null}
            <Inspector />
            <FlowInspector />
            <BulkPanel />
            <ConfirmDialog />
            <Notice />
            {nodes.length > 0 ? <SafeToSpend nodes={openingNodes} result={result} /> : null}
          </>
        )}
      </div>
    </div>
  );
}
